// The site's own words: the home page, About, Privacy, and the heading and
// introduction over each list. Each is a title and a body of markdown, edited in
// place by the admin or from Claude Desktop, and kept in `site_pages` once it has
// been. Until then a page reads as written here, so a fresh database — or a new
// page added to this list — never shows a blank.
//
// The set is fixed: a page here is a route in the client, not something a save
// can invent.
export const SITE_PAGES = [
    {
        id: "home",
        path: "/",
        title: "Reading the Bible on its own terms",
        bodyMd: "Every chapter here is the ESV text with the commentary on it beside the verses, verse by verse, with the counseling implications and the sources it rests on. Not another Bible reader — a chapter is here because there is something to say about it. Free to use, no ads.",
    },
    {
        id: "about",
        path: "/about",
        title: "Welcome to The Bible Unleashed",
        bodyMd: [
            "This is a personal project: a chapter-by-chapter commentary shaped by my own convictions, not another Bible reader with commentary hung off it. A chapter is here because there's something to say about it — the ESV text runs beside the writing, verse by verse, with the counseling implications and sources it rests on.",
            "I'm amillennial in my eschatology and traditional in my soteriology — not a Calvinist. It's easy to find commentary built on Calvinist and dispensational assumptions; it's much harder to find one that starts from where I do.",
            "More than that, I think the supernatural world the Bible actually describes has been dulled by centuries of tradition — much of it reactionary, forged in real struggles the church faced, but shaped more by what it was arguing against than by the text itself. I want to read the Bible on its own terms: the Word of God, given to particular people in a particular time, for the benefit of believers in every time since. My aim is a commentary that lets that worldview come through rather than stay hidden behind what's been built on top of it.",
            "I'm also a biblical counselor, so every chapter includes counseling implications alongside the commentary, and I plan to tag each verse for easy reference as the site grows.",
            "Free to use, no ads. I update it as study allows — check back often.",
            "— Dave Whalen",
        ].join("\n\n"),
    },
    {
        id: "privacy",
        path: "/privacy",
        title: "Privacy & cookies",
        bodyMd: [
            "This is a one-person site, not a company, and it collects as little about you as it can get away with. Here is everything.",
            "**The one cookie.** Signing in sets a single cookie, `bu_session`, that holds nothing but a random session id — no tracking, no third party ever sees it. It's set only when you register or sign in, and cleared when you sign out.",
            "**Your browser's storage.** Reading preferences — light or dark, font size, and the like — are kept in your browser's local storage. They stay on your device and are never sent anywhere unless you're signed in, in which case they sync to your account so they follow you between devices.",
            "**If you register.** We keep your name, email address, and a salted hash of your password — never the password itself — plus any highlights, notes, and bookmarks you save. Those are tied to your account and to nothing else. If you ask for a sign-in link by email instead of a password, that email contains the link and nothing more.",
            "**Counting readers.** The site keeps its own count of which pages are read and roughly how many people read them, so I know what is worth writing next. It does this without cookies and without any other company: each page you open is noted with the time, the kind of device (phone, tablet or desktop), the site you arrived from if there was one, and a scrambled code made from your address and browser under a key that changes every day and is then destroyed. That code cannot be turned back into you, and it cannot tie your reading on one day to the next. The same count notes when a tool is used — a search, the study panels, audio, a highlight, note or bookmark you save, signing in, a glossary word you open — with the passage it was about, a short phrase such as what you searched for, and the same scrambled code, and nothing else. Link previews, search-engine crawlers and visits from datacenters are left out.",
            "**Nobody else.** No advertising, no tracking scripts, no data sold or shared with anyone.",
            "This page describes the site as it actually works today; it will change if the site does.",
        ].join("\n\n"),
    },
    {
        id: "commentary",
        path: "/commentary",
        title: "Chapters",
        bodyMd: "Every chapter that has been worked through, with the ESV text beside the notes on it.",
    },
    {
        id: "bibliography",
        path: "/bibliography",
        title: "Bibliography",
        bodyMd: "The commentaries, lectures and translations the chapters lean on. Chapter references point back here.",
    },
    {
        id: "glossary",
        path: "/glossary",
        title: "Glossary",
        bodyMd: "Words that come up in the commentary, and what is meant by them. Each is underlined wherever it appears, in the commentary and in the scripture beside it — hover over it or tap it for its definition.",
    },
    {
        id: "counseling",
        path: "/counseling",
        title: "Counseling",
        bodyMd: "Passages by the need they speak to. Each one opens the commentary on it, with its counseling implications.",
    },
    {
        id: "resources",
        path: "/resources",
        title: "Study resources",
        bodyMd: "Charts and notes to keep beside the text.",
    },
    {
        id: "blog",
        path: "/blog",
        title: "Thoughts along the way",
        bodyMd: "",
    },
];
export const sitePageIds = SITE_PAGES.map((p) => p.id);
//# sourceMappingURL=pages.js.map